var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 15.6667 15.6667",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M7.83333 3.58333V7.83333L10.6667 9.25M14.9167 7.83333C14.9167 11.7454 11.7454 14.9167 7.83333 14.9167C3.92132 14.9167 0.75 11.7454 0.75 7.83333C0.75 3.92132 3.92132 0.75 7.83333 0.75C11.7454 0.75 14.9167 3.92132 14.9167 7.83333Z",
    stroke: "var(--stroke-0, #314158)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock01);
export default __webpack_public_path__ + "static/media/clock-01.7a4090510ba80ae501f520a4cca671bf.svg";
export { ForwardRef as ReactComponent };